import { render, staticRenderFns } from "./RecoverPasswordModal.vue?vue&type=template&id=7325e248&"
import script from "./RecoverPasswordModal.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports